import {Component} from "react"
import PropTypes from "prop-types"
import api from "../../../../../api.js"
import {toastr} from "react-redux-toastr"
import {isArray} from "validate.js"
import {Input} from "reactstrap"

class UserSavedFilter extends Component {
  static propTypes = {
    refreshToken: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      userSavedFilters: []
    }
  }

  componentDidMount() {
    this.loadSavedFilters()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.refreshToken !== this.props.refreshToken) {
      this.loadSavedFilters()
    }
  }

  loadSavedFilters = () => {
    api.freelances.savedSearch()
      .then((response) => {
        const {data} = response
        if (data && isArray(data)) {
          const options = data.map((filter, key) => {
            return {
              key: key,
              value: filter.filters,
              name: filter.name,
            }
          })
          this.setState({userSavedFilters: options})
        }
      }).catch((error) => {
        toastr.error(`Les filtres sauvegardés n'ont pas pu être chargé`)
      }).finally(() => {
        this.setState({loaded: true})
      })
  }

  loadSavedFilter = (filter) => {
    if(!filter) {
      return
    }
    const currentUrl = window.location.href
    const newUrl = new URL(currentUrl)
    newUrl.search = filter
    window.location.href = newUrl.toString()
    return
  }

  onInputChange= (event) => {
    this.loadSavedFilter(event.target.value)
  }

  render() {
    const {loaded, userSavedFilters} = this.state
    if(!loaded) {
      return null
    }
    return (
      <Input type="select" onChange={this.onInputChange}>
        <option value={null}>Choisissez un filtre</option>
        {userSavedFilters.map((filter, key) => {
          return (
            <option
              key={key}
              value={filter.value}
              onClick={() => this.loadSavedFilter(filter.value)}
              onChange={() => this.loadSavedFilter(filter.value)}
            >
              {filter.name}
            </option>
          )
        })}
      </Input>
    )
  }
}

export default UserSavedFilter
